import React from "react";
import ItemsFilter from "./ItemsFilter";
import { TextField } from "@material-ui/core";
import Select from "./Select";
import { OptionType } from "../hooks/useFilterOptions";
import {
  View,
  ItemFiltersProps,
  SelectOption,
} from "../helpers/interfaceHelper";

const ItemFilters: React.FC<ItemFiltersProps> = ({
  setFilter,
  resetFilter,
  dbViews,
  view,
  setView,
  setDefaultView,
  search,
  setSearch,
  query,
  filterList,
}) => {
  //react-select expects to be provided with options in key value pairs of {label: "", value: ""}
  //we therefore convert the options that we're providing into the above format.
  let disabledFilters: string[] = [];
  let viewOptions: SelectOption[] = [];

  if (dbViews) {
    viewOptions = dbViews.map((v) => ({
      label: v.name,
      value: v.id.toString(),
    }));

    //if the user has chosen a view, then we need to identify any filters that should be disabled.
    //we therefore find the chosen view, and retrieve the array of disabledFilters. We can then pass
    //these through to check whether the filter should be disabled or not
    const chosenView: View | undefined = dbViews.find((v) => v.id === view);
    if (typeof chosenView === "object" && chosenView !== null) {
      disabledFilters = chosenView.disabledFilters;
    }
  }

  return (
    <>
      <TextField
        label="Search"
        placeholder="Search..."
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <br />
      <br />
      <Select
        name="View"
        options={viewOptions}
        onChange={(value) => {
          resetFilter();
          setView((value as OptionType).value, dbViews);
          setDefaultView((value as OptionType).value);
        }}
        selectedValues={[view.toString()]}
        single
      />
      <br />
      {filterList.map((f) => (
        <React.Fragment key={f.property}>
          <ItemsFilter
            setFilter={setFilter}
            property={f.property}
            name={f.name}
            disabled={!!f.disabled && f.disabled(disabledFilters)}
            query={query}
            endpoint={f.endpoint}
          />
          <br />
        </React.Fragment>
      ))}
    </>
  );
};

export default ItemFilters;
